import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21e1efce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-search" }
const _hoisted_2 = { class: "setting" }

import { t } from '@/plugins/i18n'
import { ref, watch, toRaw } from 'vue'
import { cloneDeep } from 'lodash'
import type { FormInstance } from 'element-plus'
import { clearForm, setDefaultForm } from '@/util/common'
import dblclick from '@/components/BatchSearch/index'


export default /*#__PURE__*/_defineComponent({
  props: ['form'],
  emits: ['update:form', 'refresh'],
  setup(__props, { emit: emits }) {

const props = __props
const searchRef = ref<FormInstance>()



const defaultForm = {
  keywordName: '',
  amazonMsku: '',
  productSku: '',
  deliveryTaskCode: '',
  shipmentId: ''
}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const _form = ref(getForm(props.form))
watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})

const submit = () => {
  emits('update:form', cloneDeep(toRaw(_form.value)))
  emits('refresh')
}
const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
  emits('refresh')
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['searchRef'] = _value
        searchRef.value = _value
      },
      inline: true,
      model: _form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品名称')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.keywordName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.keywordName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('Amazon sku')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.amazonMsku,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.amazonMsku) = $event)),
              onDblclick: _cache[2] || (_cache[2] = ($event: any) => {_form.value.amazonMsku='';_unref(dblclick)('amazonMskuList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('sku')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.productSku,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.productSku) = $event)),
              onDblclick: _cache[4] || (_cache[4] = ($event: any) => {_form.value.productSku='';_unref(dblclick)('productSkuList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('国际发货单号')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.deliveryTaskCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.deliveryTaskCode) = $event)),
              onDblclick: _cache[6] || (_cache[6] = ($event: any) => {_form.value.deliveryTaskCode='';_unref(dblclick)('deliveryTaskCodeList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('补货批次号')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.shipmentId,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_form.value.shipmentId) = $event)),
              onDblclick: _cache[8] || (_cache[8] = ($event: any) => {_form.value.shipmentId='';_unref(dblclick)('shipmentIdList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: resetForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})